module.exports = __webpack_public_path__ + "img/star3-10.f38c0e1e.svg";